import React, { useEffect, useState ,useRef} from "react";
import axios from "axios";
import { Table, Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import { Avatar_02, Avatar_01 } from "../../../../../Routes/ImagePath";
import AddSalaryModal from "../components/AddSalaryModal";
import ApproveSalaryModal from "../components/ApproveSalaryModal";
import * as XLSX from "sheetjs-style";


const SalaryTable = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null); // Track the employee being edited
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedApprovedEmployee, setSelectedApprovedEmployee] = useState(null);
  const [salaryHeads, setSalaryHeads] = useState([]);
  const maximizeBtnRef = useRef(null);
  const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);


  useEffect(() => {
    if (isApproveModalVisible && selectedEmployee) {
      // Perform any logic needed before rendering the modal
      console.log("Modal is ready to render with:", selectedEmployee);
    }
  }, [isApproveModalVisible, selectedEmployee]);

  
  
  // Fetch employee salaries from API
  const fetchEmployeeSalaries = async () => {
    try {
      const response = await axios.get(`${apiUrl}/payroll/employee-salaries`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEmployees(response.data.data); // Assuming API returns { data: [...] }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching salary data:", error);
      toast.error("Failed to fetch salary data. Please try again.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployeeSalaries();
  }, []);



  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
  
    // Header Information
    const companyName = "XYZ Company Name";
    const monthYear = moment().format("MMMM YYYY");
    const sheetHeading = `Employee Salary Report ${monthYear}`;
  
    // Add header rows
    const headerData = [
      [`${companyName}`], // First row: Company Name
      [`${sheetHeading}`], // Second row: Salary Heading
      [
        "Name",
        "Employee ID",
        "Designation",
        "Department",
        "Gross Salary",
        "Deductions",
        "Net Salary",
        "Last Revision",
        "Last Payout",
      ], // Table headers
    ];
  
    // Populate table rows
    const tableBody = filteredEmployees.map((emp) => [
      emp.name,
      emp.empcode,
      emp.designation_name,
      emp.department_name,
      emp.gross_salary || 0,
      emp.deductions || 0,
      emp.net_salary || 0,
      emp.last_revision ? moment(emp.last_revision).format("MMM DD, YYYY") : "N/A",
      emp.last_payout ? moment(emp.last_payout).format("MMM DD, YYYY") : "N/A",
    ]);
  
    // Calculate totals
    const totalGross = filteredEmployees.reduce(
      (sum, emp) => sum + Number(emp.gross_salary || 0),
      0
    );
    const totalDeductions = filteredEmployees.reduce(
      (sum, emp) => sum + Number(emp.deductions || 0),
      0
    );
    const totalNet = filteredEmployees.reduce(
      (sum, emp) => sum + Number(emp.net_salary || 0),
      0
    );
  
    // Add totals row
    tableBody.push([]);
    tableBody.push([
      "TOTAL",
      "",
      "",
      "",
      totalGross.toFixed(2), // Ensure toFixed works
      totalDeductions.toFixed(2),
      totalNet.toFixed(2),
      "",
      "",
    ]);
  
    // Combine headers and body
    const sheetData = [...headerData, ...tableBody];
  
    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  
    // Merge cells for Company Name and Salary Heading
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }, // Merge Company Name across all columns
      { s: { r: 1, c: 0 }, e: { r: 1, c: 8 } }, // Merge Salary Heading across all columns
    ];
  
    // Column Widths
    worksheet["!cols"] = [
      { wch: 20 }, // Name
      { wch: 15 }, // Employee ID
      { wch: 20 }, // Designation
      { wch: 20 }, // Department
      { wch: 15 }, // Gross Salary
      { wch: 15 }, // Deductions
      { wch: 15 }, // Net Salary
      { wch: 20 }, // Last Revision
      { wch: 20 }, // Last Payout
    ];
  
    // Apply styles for all cells
    Object.keys(worksheet).forEach((cellAddress) => {
      if (!cellAddress.startsWith("!")) {
        worksheet[cellAddress].s = {
          font: { name: "Arial", sz: 10, bold: false },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    });
  
    // Styles for Company Name
    worksheet["A1"].s = {
      font: { bold: true, sz: 18 },
      alignment: { horizontal: "center", vertical: "center" },
    };
  
    // Styles for Salary Heading
    worksheet["A2"].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center", vertical: "center" },
    };
  
    // Styles for column headers
    headerData[2].forEach((_, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 2, c: index });
      worksheet[cellAddress].s = {
        font: { bold: true, sz: 12 },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
    });
  
    // Apply right alignment for numeric columns and bold for totals
    tableBody.forEach((row, rowIndex) => {
      row.forEach((_, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 3, c: colIndex }); // Offset for headers
        if ([4, 5, 6].includes(colIndex)) {
          worksheet[cellAddress].s.alignment = { horizontal: "right" }; // Right-align numeric columns
        }
      });
    });
  
    // Bold and larger font for totals row
    const totalRowIndex = headerData.length + tableBody.length - 1;
    tableBody[tableBody.length - 1].forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: colIndex });
      worksheet[cellAddress].s = {
        font: { bold: true, sz: 12 },
        alignment: { horizontal: colIndex >= 4 ? "right" : "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
    });
  
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Salary");
  
    // Export workbook
    XLSX.writeFile(workbook, `Employee_Salary_Report_${moment().format("YYYYMMDD")}.xlsx`);
  };
  


  const handleApproveSalary = async (record) => {
    try {
        setTimeout(() => setIsApproveModalVisible(true), 0); // Ensure state is updated before rendering the modal
      const response = await axios.post(
        `${apiUrl}/payroll/approve-salary`,
        { revision_id: record.id }, // Include other necessary payload details
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message || "Salary approved successfully!");
      fetchEmployeeSalaries(); // Refresh the data
    } catch (error) {
      console.error("Error approving salary:", error);
      toast.error("Failed to approve salary. Please try again.");
    }
  };

  

  // Handle Search
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  // Function to open the Add/Revise Salary Modal
  const handleAddOrReviseSalary = async (employee) => {
    setSelectedEmployee(employee); // Set the selected employee
  
    // Fetch salary heads from API
    try {
      const response = await axios.get(`${apiUrl}/payroll/salary-heads`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSalaryHeads(response.data); // Assuming API response is an array of salary heads
    } catch (error) {
      console.error("Error fetching salary heads:", error);
    }
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalVisible(false); // Hide modal
    setCurrentEmployee(null); // Reset current employee
  };

  // Define columns for Ant Design table
  const columns = [

    {
      title: " ",
      key: "actions",
      render: (_, record) => {
        const salaryStatus = record.salary_status;
    
        if (salaryStatus === "Pending Approval") {
          return (
            <Button
              className="salary-action-btn approve"
              onClick={() => {
                setTimeout(() => setIsApproveModalVisible(true), 2000); // Ensure state is updated before rendering the modal
                setIsApproveModalVisible(true);
                setSelectedApprovedEmployee(record);
              }}
              data-bs-toggle="modal"
              data-bs-target="#approve_salary"
            >
              Approve
            </Button>
          );
        } else {
          let buttonLabel = "";
          let buttonClass = "";
    
          if (salaryStatus === "New") {
            buttonLabel = "Define Salary";
            buttonClass = "salary-action-btn define";
          } else if (salaryStatus === "Existing") {
            buttonLabel = "Revise Salary";
            buttonClass = "salary-action-btn revise";
          } else {
            buttonLabel = "Unknown Action";
            buttonClass = "salary-action-btn";
          }
    
          return (
            <Button
              className={buttonClass}
              data-bs-toggle="modal"
              data-bs-target="#add_salary"
       
              onClick={() => {
                setIsApproveModalVisible(false); // Show the modal
                
                handleAddOrReviseSalary(record);
              }}

            >
              {buttonLabel}
            </Button>
          );
        }
      },
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to={`/profile/${record.id}`} className="avatar">
            <img
              src={
                record.profile_pic
                  ? `${cdnUrl}/${record.profile_pic}`
                  : record.gender === "male"
                  ? Avatar_01
                  : Avatar_02
              }
              alt="Employee Avatar"
            />
          </Link>
          <Link to={`/profile/${record.id}`}>
            {text} <span>{record.lastname}</span>
          </Link>
        </span>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
      width: 270,
    },

    
    {
      title: "Employee ID",
      dataIndex: "empcode",
      key: "empcode",
      sorter: (a, b) => a.empcode.localeCompare(b.empcode),
      width:200,
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      sorter: (a, b) => a.department_name.localeCompare(b.department_name),
    },
    {
      title: "Designation",
      dataIndex: "designation_name",
      key: "designation_name",
      sorter: (a, b) => a.designation_name.localeCompare(b.designation_name),
    },
    {
      title: "Gross Salary",
      dataIndex: "gross_salary",
      key: "gross_salary",
      render: (text) => (text ? `$${text}` : "N/A"),
      sorter: (a, b) => a.gross_salary - b.gross_salary,
    },
    {
      title: "Deductions",
      dataIndex: "deductions",
      key: "deductions",
      render: (text) => (text ? `$${text}` : "N/A"),
      sorter: (a, b) => a.deductions - b.deductions,
    },
    {
      title: "Net Salary",
      dataIndex: "net_salary",
      key: "net_salary",
      render: (text) => (text ? `$${text}` : "N/A"),
      sorter: (a, b) => a.net_salary - b.net_salary,
    },
    {
      title: "Last Salary Revision",
      dataIndex: "last_revision",
      key: "last_revision",
      render: (date) => (date ? moment(date).format("MMM DD, YYYY") : "N/A"),
      sorter: (a, b) => new Date(a.last_revision) - new Date(b.last_revision),
    },
    {
      title: "Last Payout Date",
      dataIndex: "last_payout",
      key: "last_payout",
      render: (date) => (date ? moment(date).format("MMM DD, YYYY") : "N/A"),
      sorter: (a, b) => new Date(a.last_payout) - new Date(b.last_payout),
    },
  ];
  

  // Filter employees based on search input
  const filteredEmployees = employees.filter(
    (employee) =>
      employee.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      employee.empcode.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>

<div className="page-wrapper">
  <div className="content container-fluid">
    {/* Page Header */}
    <div className="page-header page-top-icons">
      <div className="row align-items-center">
        {/* Page Title */}
        <div className="col-md-4">
          <h3 className="page-title">Employees Salary</h3>
        </div>

        {/* Action Icons */}

        <div className="col-md-4">
        <Input
          placeholder="Search by Name or ID"
          prefix={<SearchOutlined />}
          value={searchValue}
          onChange={handleSearch}
        />
      </div>

        <div className="col-md-4 d-flex justify-content-end">
          <div className="d-flex title-head">
            <div className="view-icons">
              {/* Grid View */}
              <Link to="/employees" className="grid-view btn btn-link active mx-2" aria-label="Grid View">
                <i className="fa fa-th" />
              </Link>

              {/* List View */}
              <Link to="/employees-list" className="list-view btn btn-link" aria-label="List View">
                <i className="fa fa-bars" />
              </Link>

              {/* Filter */}
              <Link
                to="#"
                className="list-view btn btn-link"
                data-bs-toggle="modal"
                data-bs-target="#scrollable-modal"
                aria-label="Filter"
              >
                <i className="las la-filter" />
              </Link>

              {/* Expand/Collapse */}
              <Link
                to="#"
                className="list-view btn btn-link"
                id="collapse-header"
                ref={maximizeBtnRef}
                aria-label="Expand"
              >
                <i className="las la-expand-arrows-alt" />
              </Link>

              {/* Refresh */}
              <Link to="#" className="grid-view btn btn-link" aria-label="Refresh">
                <i className="las la-redo-alt" />
              </Link>

              {/* Export */}
              
              <Link
                to="#"
                className="grid-view btn btn-link"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default navigation behavior
                  handleExport(); // Call the export function
                }}
              >
                <i className="las la-file-export" />
              </Link>



              {/* Import */}
              <Link
                to="#"
                className="list-view btn btn-link"
                data-bs-toggle="modal"
                data-bs-target="#import_employees"
                aria-label="Import"
              >
                <i className="las la-file-import" />
              </Link>
            </div>

            {/* Add Employee Button */}
      
          </div>
        </div>
      </div>
    </div>

    {/* Search and Filter Section */}


    {/* Employee Table Section */}
    <div className="row">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table
            className="table-striped"
            columns={columns.map((col, index) => {
              // Freeze the first 4 columns
              if (index < 1) {
                return { ...col, width:150, fixed: 'left'  };
              }
              if (index < 2) {
                return { ...col, width:250, fixed: 'left' };
              }
          
              return col;

            })}
         
            dataSource={filteredEmployees}
            rowKey={(record) => record.id}
            loading={loading}
            scroll={{
              x: 3500, // Set horizontal scroll width (adjust based on total table width)
              y: 400,  // Optional: Set vertical scroll height
            }}
           
          />
        </div>
      </div>
    </div>
  </div>
</div>

{/* Always render the AddSalaryModal */}
<AddSalaryModal
  isVisible={!!selectedEmployee} // Dynamically control visibility
  employee={selectedEmployee || {}} // Default to empty object if selectedEmployee is null
  salaryHeads={salaryHeads} // Pass salary heads as a prop
  onClose={() => {
    setSelectedEmployee(null); // Reset the selected employee when modal is closed
  }}
  onDefineSalary={async () => {
    try {
      // Fetch updated employee salary data
      const response = await axios.get(`${apiUrl}/payroll/employee-salaries`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEmployees(response.data.data); // Update the employee list in the parent state
    } catch (error) {
      console.error("Error refreshing employee salary data:", error);
      toast.error("Failed to refresh data after defining salary.");
    }
  }}
/>





<ApproveSalaryModal
  isVisible={isApproveModalVisible} // Pass visibility state directly
  employee={selectedApprovedEmployee || {}} // Ensure employee defaults to an empty object if null
  onApprove={async (id) => {
    try {
      const response = await axios.get(`${apiUrl}/payroll/employee-salaries`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployees(response.data.data);
      toast.success("Salary approved and data refreshed successfully!");
      setIsApproveModalVisible(false); // Close the modal
    } catch (error) {
      console.error("Error updating employee salary data:", error);
      toast.error("Failed to refresh data after approval. Please try again.");
    }
  }}
  onReject={async (id, comments, employee_id) => {
    try {
      const response = await axios.post(
        `${apiUrl}/payroll/reject-salary`,
        { revision_id: id, comments, employee_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const refreshedResponse = await axios.get(`${apiUrl}/payroll/employee-salaries`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployees(refreshedResponse.data.data);
      toast.success(response.data.message || "Salary rejected and data refreshed successfully!");
      setIsApproveModalVisible(false); // Close the modal
    } catch (error) {
      console.error("Error rejecting salary:", error);
      toast.error("Failed to refresh data after rejection. Please try again.");
    }
  }}
  onClose={() => setIsApproveModalVisible(false)} // Close modal on cancel or save
/>




    </>
  );
};

export default SalaryTable;
